import { Payment } from "../payment";
import { ContractCondonationInfoResponse } from "../response/contract-condonation-info-response";
import { ContractQuota } from "../response/open-documents-and-quotas-response";
import { RecollectionRepairshopInvoiceRequestModel } from "./recollection-repairshop-invoice-request-model";

export class RecollectionRequestModel{
  payments:Array<Payment> | undefined;
  quotas:Array<ContractQuota> | undefined;
  salesOrg:String | undefined;
  branchCode:String | undefined;
  registerCode:String | undefined;
  contractNumber:String | undefined;
  isPayoffComplete:boolean | undefined;
  totalToPayoff:number | undefined;
  currentInterestForPayoff:number | undefined;
  totalCharges: number | undefined;
  // condonationResponseModel: ContractCondonationInfoResponse | undefined;

  constructor(){
    this.payments = new Array();
    this.quotas = new Array();
    this.salesOrg = "";
    this.branchCode = "";
    this.registerCode = "";
    this.contractNumber = "";
    this.isPayoffComplete = false;
    this.totalToPayoff = 0;
    this.totalCharges = 0;
  }

}

export class RecollectionRepairshopRequestModel{
  payments:Array<Payment> | undefined;
  documents:Array<RecollectionRepairshopInvoiceRequestModel> | undefined;
  salesOrg:String | undefined;
  branchCode:String | undefined;
  registerCode:String | undefined;
  contractNumber:String | undefined;
  useRtn:boolean | undefined;

  constructor(){
    this.payments = new Array();
    this.documents = new Array();
    this.salesOrg = "";
    this.branchCode = "";
    this.registerCode = "";
    this.contractNumber = "";
    this.useRtn = false;
  }

}
